import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class MVROrder extends AbstractModel {
  @autoserialize
  screeningId: number;

  @autoserialize
  driverId: number;

  @autoserialize
  mvrOrderId: string;

  @autoserialize
  status: string;

  @autoserialize
  result: string;

  @autoserializeAs(Date)
  createdDateTime: Date;

  public static OnSerialized(instance: MVROrder, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.createdDateTime)) {
      json.createdDateTime = DateUtil.serializeDate(instance.createdDateTime);
    }
  }

  public static OnDeserialized(instance: MVROrder, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['createdDateTime'])) {
      instance.createdDateTime = DateUtil.deserializeDate(json['createdDateTime']);
    }
  }
}
